export const settings = {
  baseApiUrl: process.env.REACT_APP_BASE_API_URL,
};

export const PROMPT_TAGS = ['objective', 'guideline', 'context', 'example'];

// These need to match the action keys in Integration App
export enum ActionKey {
  RETRIEVE_AVAILABILITY = 'retrieve-availability',
  BOOK_APPOINTMENT = 'book-appointment',
  GET_EVENT_TYPES = 'get-event-types',
  LIST_BOARDS = 'list-boards',
  LIST_GROUPS = 'list-groups',
  LIST_DATA_RECORDS = 'list-data-records',
}

// Variables commonly available in Agent prompts by default
export const AGENT_PROMPT_VARIABLES: string[] = [
  '{today}',
  '{tomorrow}',
  '{agent_phone}',
  '{user_phone}',
];

export const HipaaCopyEnabled = 'HIPAA Compliance Enabled';
